import { Expose } from 'class-transformer';
import {
    IsBoolean,
    IsEmail,
    IsEnum,
    IsInt,
    IsOptional,
    IsString,
    MaxLength,
} from 'class-validator';

export enum CityPaymentScopeDtoEnum {
    ROUTE = 'route',
    CITY = 'city',
    QUEST = 'quest',
    PASS = 'pass',
}

/**
 * Веб-чекаут без регистрации: аккаунт заводится постфактум, по email из
 * Stripe-сессии. Поэтому эндпоинт публичный, а игрок в теле опционален.
 */
export class CreateCheckoutSessionDto {
    @IsEnum(CityPaymentScopeDtoEnum)
    @Expose()
    scope: CityPaymentScopeDtoEnum;

    /** routeId / cityId / questId. Для pass не нужен. */
    @IsOptional()
    @IsInt()
    @Expose()
    scopeId?: number | null;

    /** Токен партнёрского клейма из cookie `rt_ref` или localStorage. */
    @IsOptional()
    @IsString()
    @MaxLength(128)
    @Expose()
    claimToken?: string;

    /** Промокод площадки, введённый руками с буклета, когда `ref` потерялся. */
    @IsOptional()
    @IsString()
    @MaxLength(32)
    @Expose()
    promocode?: string;

    /** Мягко захваченный на лендинге email — предзаполняет форму Stripe. */
    @IsOptional()
    @IsEmail()
    @Expose()
    email?: string;

    /** Язык страницы: Stripe локализует свою форму. */
    @IsOptional()
    @IsString()
    @MaxLength(8)
    @Expose()
    locale?: string;

    /** Относительный путь страницы, с которой ушли платить. */
    @IsOptional()
    @IsString()
    @MaxLength(512)
    @Expose()
    returnPath?: string;

    /** Согласие с условиями и политикой; фиксируется в append-only логе. */
    @IsOptional()
    @IsBoolean()
    @Expose()
    consent?: boolean;

    /**
     * Анонимный distinct id PostHog с витрины. Вебхук склеивает его с
     * аккаунтом игрока, чтобы визит и оплата были одним человеком.
     */
    @IsOptional()
    @IsString()
    @MaxLength(200)
    @Expose()
    analyticsDistinctId?: string;
}
